/* ======================  SCRIPTS ====================== */
/************  JQUERY EST DISPONIBLE ICI *****************/

    $('document').ready(setup);
    $(window).on('load', documentReady);

    function setup() {
        initTarteAuCitron();
        initSlickSliderArtist();
        initSlickSliderTestomonial();
        initBlockMedia();
        initToolNetwork();
        initMenu();
        initBlockMedia();
        initResetPasswordPage();
        $(".burger").click(showMenuBurger);
        $('#sendinbluenewsletter-footer').submit(checkFooterNewsletterForm);
        $('#sendinbluenewsletter-footer .btn').click(checkFooterNewsletterForm);
        $('.filter').click(showHideFilters);
        $('.loadMore').click(loadMoreArtist);
        if ($('.read-me-description').length) initPopUp();
        $('#login1').attr('novalidate', 'novalidate');
    }

    function documentReady() {
        if ($('.grid').length) initGallery();
    }

    function initTarteAuCitron() {
        tarteaucitron.init({
            "hashtag": "#tarteaucitron", /* Ouverture automatique du panel avec le hashtag */
            "highPrivacy": true, /* désactiver le consentement implicite (en naviguant) ? */
            "orientation": "bottom", /* le bandeau doit être en haut (top) ou en bas (bottom) ? */
            "adblocker": false, /* Afficher un message si un adblocker est détecté */
            "showAlertSmall": true, /* afficher le petit bandeau en bas à droite ? */
            "cookieslist": false, /* Afficher la liste des cookies installés ? */
            "removeCredit": true, /* supprimer le lien vers la source ? */
            "useExternalCss": true
        });

        tarteaucitron.user.googletagmanagerId = 'GTM-NGLF6C6';
        tarteaucitron.user.facebookpixelId = '1320496771631462';
        (tarteaucitron.job = tarteaucitron.job || []).push('googletagmanager');
        (tarteaucitron.job = tarteaucitron.job || []).push('youtube');
        (tarteaucitron.job = tarteaucitron.job || []).push('facebookpixel');
    }

    // Fonction pour initialiser les sliders avec Slick
    function initSlickSliderArtist() {
        $('.blocksliderartist-cards').slick({
            dots: false,
            arrows: true,
            infinite: true,
            autoplay: false,
            speed: 2600,
            slidesToShow: 2,
            responsive: [
                {
                    breakpoint: 5000,
                    settings: {
                        slidesToScroll: 2,
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    function initSlickSliderTestomonial() {
        $('.blocktestimony-cards').slick({
            dots: false,
            arrows: true,
            infinite: false,
            autoplay: false,
            speed: 2600,
            slidesToShow: 1,
        });
    }

    function initMenu() {
        $('#mainav-primary .sub-menu').each(function () {
            $(".sub-menu").before($("<span class='icon icon-sub-menu'><span class='sr-only'>Sous-menu</span></span>"));
        });

        $(window).resize(function () {
            if ($(window).outerWidth() < 1200) {
                $('.menu-item-has-children').click(function () {
                    if ($(this).hasClass("active") === true) {
                        $(this).removeClass("active");
                        $(this).removeClass("open-sub-menu");
                        $(this).find('.icon-sub-menu').removeClass("active");
                    } else {
                        $(this).addClass("active");
                        $(this).addClass("open-sub-menu");
                        $(this).find('.icon-sub-menu').addClass("active");
                    }
                });
            }
        });

        if (window.matchMedia("(max-width:1200px)").matches) {
            $('.menu-item-has-children').click(function () {
                if ($(this).hasClass("active") === true) {
                    $(this).removeClass("active");
                    $(this).removeClass("open-sub-menu");
                    $(this).find('.icon-sub-menu').removeClass("active");
                } else {
                    $(this).addClass("active");
                    $(this).addClass("open-sub-menu");
                    $(this).find('.icon-sub-menu').addClass("active");
                }
            });
        }

        // Vérifiation et traitement AJAX Formulaire de login
        $('#login1').submit(function (e) {
            e.preventDefault();
            let nbChampVide = 0;
            $(this).find('.error-msg').fadeOut(300);
            $(this).find('.errorMsg').fadeOut(200);

            // Vérification de l'email
            if($(this).find('#user_login').val() == '' || $(this).find('#user_login').val() == ' ') {
                $(this).find('#user_login').addClass('error');
                if($(this).find('#user_login').parent().children('.error-msg').length === 0) {
                    $(this).find('#user_login').parent().append('<div class="error-msg">Veuillez renseigner votre email.</div>');
                }else {
                    $(this).find('#user_login').parent().children('.error-msg').html('Veuillez renseigner votre email.');
                }
                $(this).find('#user_login').parent().find('.error-msg').fadeIn(300);
                nbChampVide++;
            }else {
                var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/gim;
                if (regex.test($(this).find('#user_login').val()) == false) {
                    $(this).find('#user_login').addClass('error');
                    if($(this).find('#user_login').parent().children('.error-msg').length === 0) {
                        $(this).find('#user_login').parent().append('<div class="error-msg">Veuillez renseigner une adresse email valide.</div>');
                    }else {
                        $(this).find('#user_login').parent().children('.error-msg').html('Veuillez renseigner une adresse email valide.');
                    }
                    $(this).find('#user_login').parent().find('.error-msg').fadeIn(300);
                    nbChampVide++;
                }else {
                    $(this).find('#user_login').parent().find('.error-msg').fadeOut(300);
                    $(this).find('#user_login').removeClass('error');
                }
            }

            // Vérification du mot de passe
            if($(this).find('#user_pass').val() == '' || $(this).find('#user_pass').val() == ' ') {
                $(this).find('#user_pass').addClass('error');
                if($(this).find('#user_pass').parent().children('.error-msg').length === 0) {
                    $(this).find('#user_pass').parent().append('<div class="error-msg">Veuillez renseigner votre mot de passe.</div>');
                }
                $(this).find('#user_pass').parent().find('.error-msg').fadeIn(300);
                nbChampVide++;
            }else {
                $(this).find('#user_pass').removeClass('error');
                $(this).find('#user_pass').parent().find('.error-msg').fadeOut(300);
            }

            if(nbChampVide === 0) {
                // Connexion en AJAX
                $.ajax({
                    type: "POST",
                    url: $(this).attr('action'),
                    data: $(this).serialize(),
                    beforeSend: function() {
                        $('#login1').parent().addClass('loading');
                    },
                    success: function(data) {
                        $('#login1').parent().removeClass('loading');
                        $('#login1 .errorMsg').remove();
                        if(data.indexOf('Identifiant inconnu') !== -1
                            || data.indexOf('Adresse e-mail inconnue') !== -1
                            || data.indexOf('ce mot de passe ne correspond pas') !== -1
                            || data.indexOf('is not registered on this site') !== -1
                            || data.indexOf('le mot de passe que vous avez saisi pour') !== -1) {
                           $('#login1 .login-password').after('<div class="errorMsg">Votre email ou votre mot de passe n\'ont pas été reconnus.  Veuillez réessayer en vérifiant votre saisie.</div>');
                            $('#login1 .login-password input').val('');
                       }else {
                           $('#login1').parent().removeClass('loading');
                           $('#hidden-login').html('<span class="navigation-login-popin-title h4-title">Connexion à l\'espace Artistes</span><p class="success-login">Vous êtes bien connecté. La page où vous êtes sera rafraichie dans <b><span class="counter">5</span> secondes</b>.</p>');
                           afterLoggedArtist();
                       }
                    },
                    error: function(xhr, textStatus) {
                        $('#login1').parent().removeClass('loading');
                        $('#login1 .errorMsg').remove();
                        $('#login1 .login-password').after('<div class="errorMsg">Nous n\'avons pas pu vous connecter. Veuillez réessayer ultérieurement ou contacter l\'administrateur du site. </div>');
                    }
                });
            }
        });

        $('#showLogin').fancybox({
            buttons: ["close"],
            touch: false
        });

        $(".espace-artistes-mobile").click(function(){
            $('#showLogin').trigger('click');
        });
    }

    function initResetPasswordPage() {
        if($('#resetpasswordform').length !== 0) {
            $('#som_new_user_pass').parent().children('label').html('Nouveau mot de passe');
            $('#som_new_user_pass_again').parent().children('label').html('Retapez le mot de passe');
            $('#resetpasswordform label').css('opacity', '1');
        }
    }

    function afterLoggedArtist() {
        var timer = 5;
        var interval = setInterval(function(){
            timer = timer - 1;
            $('#hidden-login').find('.counter').html(timer);
            if(timer === 0) {
                clearInterval(interval);
                location.reload();
            }
        }, 1000);
    }

    // Fonction pour le scrool des réseaux sociaux
    function initToolNetwork() {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 710) {
                $('.network-artnefs').css({'position': 'fixed', 'z-index': '5'});
            } else {
                $('.network-artnefs').css({'position': 'absolute', 'z-index': '0'});
            }
        });
    }

    // Fonction qui permet de lire une vidéo
    function initBlockMedia() {
        $('.blocktextimg-media.has-video, .blockmedia-media.has-video').click(function () {
            if (!$(this).hasClass('showVideo')) $(this).addClass('showVideo');
        });
    }

    // Fonction menu responsive
    function showMenuBurger() {
        if ($('.navigation-menu').hasClass("active") === true) {
            $('.navigation-menu').removeClass("active");
            $('body').removeClass("open-menu");
            $(this).removeClass('open');
            setTimeout(function () {
                $('.navigation-menu').css({"transform": "translateX(125%)", "height": "100vh"});
            }, 500);
        } else {
            $('.navigation-menu').removeClass("active");
            $('.navigation-menu').addClass("active");
            $('body').addClass("open-menu");
            $(this).addClass('open');
            setTimeout(function () {
                $('.navigation-menu').css({"transform": "translateX(0%)", "height": "100vh"});
            }, 500);
        }
    }

    // Fonction pop up page d'un artiste
    function initPopUp() {
        var btnCloseTag = '<a class="trigger-close"></a>';
        $('.modal-wrapper').each(function () {
            $(this).append(btnCloseTag);
        });
        $('.read-me-description').click(function () {
            $('html').toggleClass('modal-locked');
            var id = $(this).data('target');
            $('#' + id).toggleClass('open');
            return false;
        });
        $('.trigger-close').click(function () {
            var uuu = $(this).closest('.modal-wrapper').find('[class=modal-content]');
            uuu.addClass('overflowVisible');
            $(this).closest('.modal-wrapper').toggleClass('open');
            setTimeout(function () {
                $('html').toggleClass('modal-locked');
                uuu.removeClass('overflowVisible');
            }, 190);
            return false;
        });
    }

    // Fonction newsletters
    function checkFooterNewsletterForm(e) {
        e.preventDefault();
        $('#sendinbluenewsletter-footer .error-msg').fadeOut(100);
        var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/gim;
        if (regex.test($('#email_newsletter').val()) == false) {
            $(this).parent().children('.error-msg').fadeIn(300);
        } else {
            $('#sendinbluenewsletter-footer input[name="botOrNotBot_newsletter"]').val('imNotBot');
            $.ajax({
                type: "GET",
                url: $('#sendinbluenewsletter-footer').attr('action'),
                data: $('#sendinbluenewsletter-footer').serialize(), // serializes the form's elements.
                beforeSend: function () {
                    $('.fadebg').fadeIn(200);
                },
                success: function (data) {
                    $('#sendinbluenewsletter-footer input, #sendinbluenewsletter-footer .btn').fadeOut(200);
                    $('#sendinbluenewsletter-footer .error-msg').html('');
                    $('#sendinbluenewsletter-footer .error-msg').addClass('validMsg');
                    $('#sendinbluenewsletter-footer .error-msg').fadeIn(0);
                    $('#sendinbluenewsletter-footer .error-msg').removeClass('error-msg');
                    $('.fadebg').fadeOut(0);
                    document.location.href="/confirmation-nl";
                },
                error: function () {
                    $('#sendinbluenewsletter-footer .error-msg').html('Votre inscription n\'a pas pu être validée, merci de réessayer.');
                    $('#sendinbluenewsletter-footer .error-msg').fadeIn(200);
                }
            });
        }
    }

    // Afficher/Cacher les filtres des cas clients
    function showHideFilters() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).children('ul').slideUp(500);
        } else {
            $('.filter.active').removeClass('active');
            $('.filter ul').slideUp(500);
            $(this).addClass('active');
            $(this).children('ul').slideDown(500);
        }
    }

    function initGallery() {
        $('.grid').isotope({
            masonry: {
                itemSelector: '.grid-item',
                percentPosition: true,
                columnWidth: '.grid-sizer',
                gutter: 20
            }
        });

        $('[data-fancybox="gallery"]').fancybox({
            buttons: [
                "zoom",
                "close"
            ]
        });


        $('.list-univers-gallery li').click(function () {
            $('.list-univers-gallery li').each(function () {
                $(this).removeClass('active');
            });
            $(this).addClass('active');
            var idUnivers = $(this).data('univers');

            $('.grid').isotope({
                filter: '.univers-' + idUnivers,
                masonry: {
                    itemSelector: '.grid-item',
                    percentPosition: true,
                    columnWidth: '.grid-sizer',
                    gutter: 20
                }
            })
        });
    }

    // Charger plus d'artiste en Ajax
    function loadMoreArtist() {
        var btnLoad = $(this);
        var offsetBsc = $(this).attr('data-nb-posts');
        var totalNbCases = $(this).attr('data-total-posts');

        var nbLoadedCases = $('.content-list-artist .card').length;
        if (nbLoadedCases < totalNbCases) {
            var data = {
                'action': 'my_ajax_filter_search_artist',
                'offset': offsetBsc,
                'security': blog.security
            };
            $.post(blog.ajaxurl, data, function (response) {
                if ($.trim(response) !== '') {
                    $('.content-list-artist').append(response);
                    var nbLoadedCases = $('.content-list-artist .card').length;
                    btnLoad.attr('data-nb-posts', nbLoadedCases);
                    if (parseInt(nbLoadedCases) === parseInt(totalNbCases)) {
                        btnLoad.removeClass('loadMore');
                    }
                } else {
                    btnLoad.removeClass('loadMore');
                }
            });
        } else {
            btnLoad.removeClass('loadMore');
        }
    }

    // Charger plus d'artiste en Ajax de la page taxonomie
    function loadMoreArtist() {
        var btnLoad = $(this);
        var offsetBsc = $(this).attr('data-nb-posts');
        var totalNbCases = $(this).attr('data-total-posts');
        var category = $(this).attr('data-univers-posts');

        var nbLoadedCases = $('.content-list-artist .card').length;
        if (nbLoadedCases < totalNbCases) {
            var data = {
                'action': 'my_ajax_filter_search_artist',
                'offset': offsetBsc,
                'category': category,
                'security': blog.security
            };
            $.post(blog.ajaxurl, data, function (response) {
                if ($.trim(response) !== '') {
                    $('.content-list-artist').append(response);
                    var nbLoadedCases = $('.content-list-artist .card').length;
                    btnLoad.attr('data-nb-posts', nbLoadedCases);
                    if (parseInt(nbLoadedCases) === parseInt(totalNbCases)) {
                        btnLoad.removeClass('loadMore');
                    }
                } else {
                    btnLoad.removeClass('loadMore');
                }
            });
        } else {
            btnLoad.removeClass('loadMore');
        }
    }
